import script from "./Invoice.vue?vue&type=script&lang=ts&setup=true"
export * from "./Invoice.vue?vue&type=script&lang=ts&setup=true"

import "./Invoice.vue?vue&type=style&index=0&id=3914ee1a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3914ee1a"]])

export default __exports__